// extracted by mini-css-extract-plugin
module.exports = {"homeIcon":"HomeIcon_homeIcon__26Imy","small":"HomeIcon_small__E_Fnd"};